import React, { useEffect, useState } from 'react';
import s from './CompletedRegistrationStep.module.css';
import { ProgressBar } from '../../ProgressBar/ProgressBar';
import { FormTitle } from '../../FormTitle/FormTitle';

export const CompletedRegistrationStep = ({ redirectUrl }) => {
    const [isStopProgress, setIsStopProgress] = useState(false);

    useEffect(() => {
        if (isStopProgress && redirectUrl) {
            window.location.href = redirectUrl;
        }
    }, [isStopProgress, redirectUrl]);

    return (
        <div className={s.completedBlock}>
            <div className={s.wrapper}>
                <div className={s.fireworkImage}>
                    <div className={s.tickImage} />
                </div>
                <div className={s.contentWrapper}>
                    <FormTitle
                        title={i18next.t('CompletedRegistrationStep.FormTitle.title')}
                        subtitle={i18next.t('CompletedRegistrationStep.FormTitle.subtitle')}
                    />
                </div>
            </div>
            <ProgressBar setIsStopProgress={setIsStopProgress} />
            <span className={s.loadingText}>
                {i18next.t('CompletedRegistrationStep.return.loadingText')}
            </span>
        </div>
    );
};
